export default __webpack_public_path__ + "static/media/curso_basico_cover.40de70ef.png";